import type { EventData } from '~/lib/types/Event'

export class EventStorage {
  constructor(private readonly storageKey: string) {}

  saveFailedEvents(events: EventData[]): void {
    if (typeof window === 'undefined') return

    try {
      const existingEvents = this.getFailedEvents()
      const allEvents = [...existingEvents, ...events]
      localStorage.setItem(this.storageKey, JSON.stringify(allEvents))
    } catch (error) {
      console.warn('Failed to save events to localStorage:', error)
    }
  }

  getFailedEvents(): EventData[] {
    if (typeof window === 'undefined') return []

    try {
      const stored = localStorage.getItem(this.storageKey)
      return stored ? JSON.parse(stored) : []
    } catch (error) {
      console.warn('Failed to load events from localStorage:', error)
      return []
    }
  }

  removeFailedEvents(eventIds: string[]): void {
    if (typeof window === 'undefined') return

    try {
      const events = this.getFailedEvents()
      const filteredEvents = events.filter((event) => !eventIds.includes(event.id))
      localStorage.setItem(this.storageKey, JSON.stringify(filteredEvents))
    } catch (error) {
      console.warn('Failed to remove events from localStorage:', error)
    }
  }

  clearAllFailedEvents(): void {
    if (typeof window === 'undefined') return

    try {
      localStorage.removeItem(this.storageKey)
    } catch (error) {
      console.warn('Failed to clear events from localStorage:', error)
    }
  }

  getFailedEventCount(): number {
    return this.getFailedEvents().length
  }
}
